module.exports = "/assets/af967d1de5042e0e1589f52bf5fdbf63.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/DN.png
// module id = 2434
// module chunks = 0